import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

let previousPathname: string | null = null;
let currentPathname: string | null = null;

export const usePreviousLocationTracker = (): void => {
  const history = useHistory();

  useEffect(() => {
    currentPathname = history.location.pathname;
    return history.listen((location) => {
      previousPathname = currentPathname;
      currentPathname = location.pathname;
    });
  }, [history]);
};

export const getPreviousPathname = (): string | null => previousPathname;

export const resetPreviousLocationForTests = (): void => {
  previousPathname = null;
  currentPathname = null;
};
